import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StudentComment, StudentCommentStatus } from './student-comment.model';
import { StudentCommentService } from './student-comment.service';
import { StudentService } from '../student/student.service';

@Injectable()
export class StudentCommentPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private StudentCommentService: StudentCommentService,
        private studentService: StudentService
    ) { }

    open(component: Component, id?: number | any  | any, studentId?: number): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.StudentCommentService.find(id).subscribe(StudentComment => {
                this.StudentCommentModalRef(component, StudentComment);
            });
        } else {
            let studentComment: StudentComment = new StudentComment();
            let openStatus: any = 'DISMISSED';
            studentComment.status = openStatus;

            if (studentId) {
                // We are creating a StudentComment for a specific student
                this.studentService.find(studentId).subscribe(student => {
                    studentComment.student = student;
                    return this.StudentCommentModalRef(component, studentComment);
                });
            }
        }
    }

    StudentCommentModalRef(component: Component, studentComment: StudentComment): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.studentComment = studentComment;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment-popup.service.ts